import styled from "styled-components";

export const Banner = styled.div`
    padding: 8px;
    font-size: 0.875rem;
    text-align: center;

    color: var(--accent);
    background: var(--primary-background);
`;
